import Card from './card';
import Form from './form';
import Modal from './modal';

export default {
    Card,
    Form,
    Modal
};
